import type { SoundEffect } from '../sound/soundEngine';

export const REACTION_EVENT_IDS = [
  'navigation.menu-open',
  'assistant.opened',
  'assistant.guidance',
  'mission.start',
  'choice.selected',
  'record.saved',
  'mission.completed',
  'quiz.correct',
  'quiz.retry',
  'world.opened',
  'badge.unlocked',
  'passport.stamped',
  'family.cheer',
  'fridge.stored',
  'day.completed',
] as const;

export type ReactionEventId = typeof REACTION_EVENT_IDS[number];
export type ReactionIntensity = 'micro' | 'moment' | 'celebration';
export type ReactionGuide = 'snows' | 'haneul' | 'sage';
export type ReactionPose = 'guide' | 'think' | 'record' | 'run' | 'surprise' | 'heart' | 'celebrate' | 'research' | 'checklist';

export interface ReactionDefinition {
  sound: SoundEffect;
  intensity: ReactionIntensity;
  guide: ReactionGuide;
  pose: ReactionPose;
  eyebrow: string;
  title: string;
  liveMessage: string;
  durationMs: number;
  haptic: number[];
  accent: 'ice' | 'gold' | 'mint' | 'rose' | 'violet';
}

export const REACTION_CATALOG: Record<ReactionEventId, ReactionDefinition> = {
  'navigation.menu-open': {
    sound:'menu-open', intensity:'micro', guide:'snows', pose:'guide', eyebrow:'전체 메뉴', title:'MRM 월드를 한눈에 볼 수 있어요', liveMessage:'전체 메뉴를 열었습니다.', durationMs:420, haptic:[10], accent:'ice',
  },
  'assistant.opened': {
    sound:'menu-open', intensity:'micro', guide:'snows', pose:'guide', eyebrow:'스노스 도우미', title:'필요한 도움을 한곳에서 찾을 수 있어요', liveMessage:'스노스 도우미를 열었습니다.', durationMs:520, haptic:[10], accent:'ice',
  },
  'assistant.guidance': {
    sound:'choice-select', intensity:'moment', guide:'snows', pose:'guide', eyebrow:'스노스 팁', title:'작은 행동 하나부터 함께 시작해요', liveMessage:'스노스가 현재 화면에 맞는 도움을 안내합니다.', durationMs:1750, haptic:[12,28,12], accent:'ice',
  },
  'mission.start': {
    sound:'mission-start', intensity:'moment', guide:'snows', pose:'guide', eyebrow:'오늘의 출발', title:'작은 선택 하나면 충분해!', liveMessage:'오늘의 미션을 시작합니다.', durationMs:1550, haptic:[18], accent:'ice',
  },
  'choice.selected': {
    sound:'choice-select', intensity:'micro', guide:'haneul', pose:'think', eyebrow:'나의 선택', title:'선택한 이유를 한 번 떠올려 봐요', liveMessage:'선택을 기록했습니다.', durationMs:620, haptic:[12], accent:'violet',
  },
  'record.saved': {
    sound:'record-complete', intensity:'moment', guide:'haneul', pose:'record', eyebrow:'기록 보관 완료', title:'오늘의 선택이 성장 기록에 쌓였어요', liveMessage:'돈 기록을 저장했습니다.', durationMs:1650, haptic:[16,35,16], accent:'mint',
  },
  'mission.completed': {
    sound:'mission-complete', intensity:'celebration', guide:'haneul', pose:'celebrate', eyebrow:'미션 완료', title:'기다리고 생각한 힘이 자랐어요!', liveMessage:'오늘의 미션을 완료했습니다.', durationMs:2200, haptic:[20,45,30], accent:'gold',
  },
  'quiz.correct': {
    sound:'quiz-correct', intensity:'moment', guide:'sage', pose:'research', eyebrow:'설옹의 발견', title:'정보를 구분하는 눈이 더 밝아졌어요', liveMessage:'정답입니다.', durationMs:1700, haptic:[14,30,14], accent:'mint',
  },
  'quiz.retry': {
    sound:'quiz-retry', intensity:'moment', guide:'sage', pose:'think', eyebrow:'다시 관찰하기', title:'틀린 게 아니라 새로운 단서를 찾는 중이에요', liveMessage:'다시 생각할 단서를 보여드립니다.', durationMs:1600, haptic:[14], accent:'violet',
  },
  'world.opened': {
    sound:'world-open', intensity:'celebration', guide:'snows', pose:'guide', eyebrow:'월드 변화', title:'새로운 공간에 불빛이 켜졌어요', liveMessage:'새로운 월드 공간이 열렸습니다.', durationMs:2300, haptic:[22,45,22], accent:'ice',
  },
  'badge.unlocked': {
    sound:'badge-unlock', intensity:'celebration', guide:'haneul', pose:'celebrate', eyebrow:'새 배지 발견', title:'나만의 성장 흔적을 얻었어요!', liveMessage:'새 배지를 획득했습니다.', durationMs:2400, haptic:[18,35,18,35,30], accent:'gold',
  },
  'passport.stamped': {
    sound:'passport-stamp', intensity:'celebration', guide:'sage', pose:'checklist', eyebrow:'금융 패스포트', title:'현실 탐험 스탬프가 찍혔어요', liveMessage:'금융 패스포트 스탬프를 받았습니다.', durationMs:2300, haptic:[28,45,18], accent:'gold',
  },
  'family.cheer': {
    sound:'family-cheer', intensity:'celebration', guide:'haneul', pose:'heart', eyebrow:'가족 응원 도착', title:'따뜻한 응원이 냥장고 집에 켜졌어요', liveMessage:'가족 응원이 도착했습니다.', durationMs:2300, haptic:[18,45,18], accent:'rose',
  },
  'fridge.stored': {
    sound:'fridge-store', intensity:'moment', guide:'haneul', pose:'heart', eyebrow:'냥장고 보관', title:'오늘의 기억을 안전하게 보관했어요', liveMessage:'성장 기록을 냥장고에 보관했습니다.', durationMs:1800, haptic:[20,35,12], accent:'mint',
  },
  'day.completed': {
    sound:'daily-complete', intensity:'celebration', guide:'snows', pose:'celebrate', eyebrow:'오늘의 눈길 완성', title:'오늘의 선택이 오로라를 밝혔어요!', liveMessage:'오늘의 성장 활동을 모두 완료했습니다.', durationMs:2600, haptic:[20,35,20,35,40], accent:'gold',
  },
};
